import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({selector:'app-qr-self-checkin', templateUrl:'./qr-self-checkin.component.html', standalone:false})
export class QrSelfCheckinComponent {
  constructor(private route: ActivatedRoute) {}
  get targetId(): number { return Number(this.route.snapshot.params.eventId); }
}
